<!--  -->
<template>
  <div class="child-box" style="height:18%">
    <div class="child-head">
      <div class="child-name">公路概况</div>
    </div>
    <div class="content">
      <div class="content-item">总路段全长：123km</div>
      <div class="content-item">截至查询时间为止的交通量：1234辆</div>
      <div class="content-item">公路交通拥堵情况：畅通</div>
      <div class="content-item">当前巡检情况：无异常</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  width: 92%;
  height: 63%;
  margin-left: 8%;
  font-size: 1.3vh;
  color: #bcdeff;
  margin-top: 5%;
  margin-bottom: 6%;
  .content-item {
    margin-top: 3%;
    height: 19%;
  }
}
</style>